import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Loading from "../components/Loading";
// import Message from "../components/Message"; // no longer needed
import { updateProfile } from "../redux/actions/userActions";
import { listMyOrders } from "../redux/actions/orderActions";
import { toast } from "react-toastify";


const ProfileScreen = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [emailFocused, setEmailFocused] = useState(false);

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const userUpdateProfile = useSelector((state) => state.userUpdateProfile);
  const { loading, successUpdated, error } = userUpdateProfile;

  const orderListMy = useSelector((state) => state.orderListMy);
  const {
    loading: loadingMyOrders,
    orders,
    error: errorMyOrders,
  } = orderListMy;

  useEffect(() => {
    if (userInfo?.name) {
      setName(userInfo.name);
      setEmail(userInfo.email);
      setContactNumber(userInfo.contactNumber || "");
      dispatch(listMyOrders());
    }
  }, [dispatch, userInfo]);

  // success toast when profile updated
  useEffect(() => {
    if (successUpdated) {
      toast.success("Profile updated successfully");
    }
  }, [successUpdated]);

  // error toast from updateProfile reducer
  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  // error toast for orders list (optional but nice)
  useEffect(() => {
    if (errorMyOrders) {
      toast.error(errorMyOrders);
    }
  }, [errorMyOrders]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !email || !contactNumber) {
      toast.error("Name, Email and Contact Number must not be empty");
      return;
    }

    // E.164 validation
    const e164Regex = /^\+[1-9]\d{1,14}$/;

    if (!e164Regex.test(contactNumber)) {
      toast.error("Enter valid number in E.164 format. Example: +919876543210");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    dispatch(
      updateProfile({
        name,
        email,
        contactNumber,
        password,
      })
    );
  };

  return (
    <Row>
      <Col md={3}>
        <h2>Update Profile</h2>

        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="name" className="mt-3">
            <Form.Label>Full Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Full Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId="email" className="mt-3">
            <Form.Label>
              Email
              {emailFocused && (
                <small style={{ color: "red", marginLeft: "8px" }}>
                  You can't change email.
                </small>
              )}
            </Form.Label>
            <Form.Control
              type="email"
              placeholder="Email"
              value={email}
              readOnly
              onFocus={() => setEmailFocused(true)}
              onBlur={() => setEmailFocused(false)}
            ></Form.Control>
          </Form.Group>

          {/* E.164 TEXT FIELD */}
          <Form.Group controlId="contactNumber" className="mt-3">
            <Form.Label>Contact Number (e.g., +91xxxxxxxxxx)</Form.Label>
            <Form.Control
              type="text"
              placeholder="+919876543210"
              value={contactNumber}
              onChange={(e) => {
                let val = e.target.value;

                val = val.replace(/\s+/g, ""); // remove spaces

                if (!val.startsWith("+")) {
                  val = "+" + val.replace(/[^0-9]/g, "");
                } else {
                  val = "+" + val.substring(1).replace(/[^0-9]/g, "");
                }

                setContactNumber(val);
              }}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId="password" className="mt-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId="confirmPassword" className="mt-3">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            ></Form.Control>
          </Form.Group>

          <Button className="mt-3" type="submit" variant="primary">
            {loading ? <Loading /> : "Update Profile"}
          </Button>
        </Form>
      </Col>

      <Col md={8}>
        <h2 style={{ marginTop: "18px" }}>My Orders</h2>

        {loadingMyOrders ? (
          <Loading />
        ) : (
          <Table striped bordered hover responsive className="table-sm mt-3">
            <thead>
              <tr>
                <td>ID</td>
                <td>DATE</td>
                <td>TOTAL</td>
                <td>PAID</td>
                <td>DELIVERED</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr key={index}>
                  <td>{order._id}</td>
                  <td>{order.createdAt.substring(0, 10)}</td>
                  <td>Rs. {order.totalPrice}</td>
                  <td>
                    {order.isPaid ? (
                      order.paidAt.substring(0, 10)
                    ) : (
                      <i className="fas fa-times" style={{ color: "red" }}></i>
                    )}
                  </td>
                  <td>
                    {order.isDelivered ? (
                      order.deliveredAt.substring(0, 10)
                    ) : (
                      <i className="fas fa-times" style={{ color: "red" }}></i>
                    )}
                  </td>
                  <td>
                    <LinkContainer to={`/order/${order._id}`}>
                      <Button className="btn btn-sm" variant="primary">
                        Details
                      </Button>
                    </LinkContainer>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Col>
    </Row>
  );
};

export default ProfileScreen;
